import React from "react";
import "./sections.scss";

function FourSec({item,link}){


    return(
        <div className="four-banner-container">
            {item.title?<div className="section-title"><span>{item.title}</span></div>:null}
            <div className="four-banner-list">
                {item.items.map(t=>{
                    return(
                        <div onClick={()=>{
                            link(t.link_to,t)
                        }}  className={`four-banner-item ${item.has_shadow?"shadow-sec":""}`} >
                            <img src={t.image} alt=""/>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default FourSec
